var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: {
        timeline: true,
        compact: _vm.isCompact,
        mobile: _vm.isMobile(_vm.$mq)
      }
    },
    [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "header-text" }, [
          _c("h2", { attrs: { "data-testid": _vm.testIdPrefix + "_header" } }, [
            _vm._v("\n        " + _vm._s(_vm.headingCopy) + "\n      ")
          ]),
          _vm._v(" "),
          _vm.subHeading
            ? _c("p", { staticClass: "subheader" }, [
                _vm._v("\n        " + _vm._s(_vm.subHeading) + "\n      ")
              ])
            : _vm._e()
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "timeline-container" }, [
          _c("hr", { attrs: { id: "timeline" } }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "trial-steps" },
            _vm._l(_vm.trialSteps, function(step) {
              return _c(
                "div",
                {
                  key: step.header,
                  class: { step: true, strikethrough: step.strikethroughHeader }
                },
                [
                  _c(
                    "div",
                    {
                      class: {
                        icon: true,
                        completed: step.completed
                      }
                    },
                    [
                      _c("div", { staticClass: "icon-container" }, [
                        _c("span", { class: step.iconClass })
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "text" }, [
                    _c("h4", [_vm._v(_vm._s(step.header))]),
                    _vm._v(" "),
                    _c(
                      "p",
                      {
                        class: { completed: step.strikethroughHeader },
                        attrs: {
                          "data-testid": _vm.testIdPrefix + "_trial_step_text"
                        }
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(step.text) +
                            "\n            "
                        )
                      ]
                    )
                  ])
                ]
              )
            }),
            0
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }